import { connect, Dispatch } from 'react-redux';

import { Action } from '../../actions';
import { updateInternalProductAction } from '../../actions/products/internal/updateInternalProduct';
import { updateInternalProductDescriptionAction } from '../../actions/products/internal/updateInternalProductDescription';
import {
    ProductDescriptionCell,
    ProductDescriptionCellProps
} from '../../components/ProductDescriptionCell/ProductDescriptionCell';
import { Product } from '../../typings/products';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

type OwnProps = Pick<ProductDescriptionCellProps, 'product'>;
type StateProps = TStateProps<ProductDescriptionCellProps, OwnProps>;
type DispatchProps = TDispatchProps<ProductDescriptionCellProps, OwnProps>;

const mapStateToProps = (state: State): StateProps => ({
    pageStatus: state.products.pageStatus,
    isGridScrolling: state.grid.isGridScrolling,
    accessRights: state.commonData.accessRights
});

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => ({
    onCancel: (product: Product) => dispatch(updateInternalProductAction(product, true)),
    onEdit: (product: Product) => dispatch(updateInternalProductAction(product, false)),
    onSave: (product: Product) => dispatch(updateInternalProductDescriptionAction(product))
});

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: DispatchProps,
    ownProps: OwnProps
): ProductDescriptionCellProps => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps
});

export const ProductDescriptionCellContainer = connect<
    StateProps,
    DispatchProps,
    OwnProps,
    ProductDescriptionCellProps
>(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(ProductDescriptionCell);
